import React from "react";
import Joyride from "react-joyride";
import { utility } from "../framework/utility/utilityProvider";
import { LOCALSTORAGE_KEY } from "../framework/constant/constant";

const UserGuides = ({ show = false, steps = [] }) => {

    const handleJoyrideCallback = (data) => {
        const { status } = data;
        if (status === "finished" || status === "skipped") {
            utility.setValue(LOCALSTORAGE_KEY.isFirstTimeLogin, false);
        }
    };

    return (
        <div>
            <Joyride
                steps={steps}
                run={show}
                continuous // Moves to the next step automatically
                scrollToFirstStep // Ensures the first step is visible
                showSkipButton // Shows a skip button
                callback={handleJoyrideCallback}
                styles={{
                    options: {
                        arrowColor: "#fff",
                        backgroundColor: "#fff",
                        overlayColor: "rgba(0, 0, 0, 0.5)",
                        primaryColor: "#0d6efd",
                        textColor: "#000",
                        zIndex: 1000,
                    },
                    tooltipContent: {
                        textAlign: 'left'
                    },
                    tooltipFooter: {
                        marginTop: '0px'
                    },
                    buttonClose: {
                        display: "none", // Hides the default close button
                    },
                }}
                locale={{
                    next: "Next", // Customize button labels
                    skip: "Skip",
                    back: "Back",
                    last: "Ok",
                }}
            />
        </div>
    );
};

export default UserGuides;
